import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { DeckAmbience } from '../SlideFrame';
import { DeckLogoPlate } from '../DeckLogo';
const EASE = [0.23, 1, 0.32, 1] as const;
export function SlideClosing({
  active
}: {
  active: boolean;
}) {
  return <div className="relative w-full h-full overflow-hidden bg-dark-navy" data-id="element-1906" data-mp="4d8rg85kv78c">
      <DeckAmbience tone="dark" data-id="element-1907" data-mp="9biraw28yw0a" />

      <div className="relative z-10 flex flex-col h-full px-16 py-14" data-id="element-1908" data-mp="9ahdwkxrdxfe">
        <motion.div className="flex items-center gap-3" initial={{
        opacity: 0,
        y: -8
      }} animate={active ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0
      }} transition={{
        duration: 0.45,
        ease: EASE
      }} data-id="element-1909" data-mp="e9u1j7wgf8j1">
          <DeckLogoPlate tone="dark" data-id="element-1910" data-mp="n25k67lbtrog" />
          <span className="text-[10px] font-semibold uppercase tracking-[0.22em] text-white/45" data-id="element-1911" data-mp="s1ry6j8zbbyb">
            Closing
          </span>
        </motion.div>

        <div className="flex-1 flex flex-col justify-center max-w-[860px]" data-id="element-1912" data-mp="x1cyawzvxqcm">
          <motion.h2 className="font-display font-bold text-[52px] leading-[1.05] tracking-tight text-white" initial={{
          opacity: 0,
          y: 20
        }} animate={active ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          ease: EASE,
          delay: 0.1
        }} data-id="element-1913" data-mp="dr2zxn1jpsws">
            The next interface for commerce is{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-cyan to-ai-purple" data-id="element-1914" data-mp="wg9nbndab8ox">
              conversation
            </span>
          </motion.h2>

          <motion.p className="mt-7 text-[19px] leading-relaxed text-white/70" initial={{
          opacity: 0,
          y: 16
        }} animate={active ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 16
        }} transition={{
          duration: 0.55,
          ease: EASE,
          delay: 0.26
        }} data-id="element-1915" data-mp="shac5l0ymfp1">
            Websites were built for browsing.{' '}
            <span className="text-white font-medium" data-id="element-1916" data-mp="1bcqyoelh4nbh">Talab is built for asking.</span>
          </motion.p>

          <div className="flex items-center gap-4 mt-10" data-id="element-1917" data-mp="1ub2abpe6qii9">
            {['Start with your own AI storefront.', 'When ready, become part of the Talab Marketplace.'].map((line, index) => <React.Fragment key={line} data-id="element-1918" data-mp="1lfmitf0wkffu" data-mpi={index}>
                {index === 1 && <motion.span initial={{
              opacity: 0
            }} animate={active ? {
              opacity: 1
            } : {
              opacity: 0
            }} transition={{
              duration: 0.4,
              delay: 0.6
            }} data-id="element-1919" data-mp="1phr8k2o8crx7">
                    <ArrowRightIcon className="w-4 h-4 text-white/30" data-id="element-1920" data-mp="1gg9lg0cenpz0" />
                  </motion.span>}
                <motion.div className="px-5 py-3 rounded-2xl bg-white/[0.06] border border-white/10 text-[13.5px] text-white/85" initial={{
              opacity: 0,
              y: 14
            }} animate={active ? {
              opacity: 1,
              y: 0
            } : {
              opacity: 0,
              y: 14
            }} transition={{
              duration: 0.45,
              ease: EASE,
              delay: 0.42 + index * 0.14
            }} data-id="element-1921" data-mp="16k6i4r5thlah">
                  {line}
                </motion.div>
              </React.Fragment>)}
          </div>
        </div>

        <motion.div className="shrink-0 flex items-end justify-between gap-10 pt-7 border-t border-white/10" initial={{
        opacity: 0
      }} animate={active ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8
      }} data-id="element-1922" data-mp="z1712s5tw5ua">
          <p className="text-[14.5px] leading-relaxed text-white/55 max-w-[560px]" data-id="element-1923" data-mp="140a7oh1gik4d">
            Talab is the new era of commerce — from browsing products to simply asking for what
            you want.
          </p>

          <address className="shrink-0 not-italic text-right" data-id="element-1924" data-mp="1d06mlqy1o4m8">
            <p className="text-[9.5px] font-semibold uppercase tracking-[0.22em] text-white/35" data-id="element-1925" data-mp="1cyvmq27pzh0e">
              Get in touch
            </p>
            <div className="flex items-center justify-end gap-2 mt-2.5" data-id="element-1926" data-mp="3esuy0nkudyd3">
              <MailIcon className="w-3.5 h-3.5 text-electric-cyan" data-id="element-1927" data-mp="3h6q8uommfl27" />
              <a href="mailto:fadi@vexu.ai" className="font-display font-bold text-[15px] text-white transition-colors duration-150 hover:text-electric-cyan" data-id="element-1928" data-mp="3h6ggiue3t1tc">
                fadi@vexu.ai
              </a>
            </div>
            <div className="flex items-center justify-end gap-2 mt-1.5" data-id="element-1929" data-mp="3v56h4k04tjmg">
              <PhoneIcon className="w-3.5 h-3.5 text-electric-cyan" data-id="element-1930" data-mp="2xj93p10m04hd" />
              <a href="tel:+971585377090" className="font-display font-bold text-[15px] text-white transition-colors duration-150 hover:text-electric-cyan" data-id="element-1931" data-mp="2xgwdy1om0ptr">
                +971 58 537 7090
              </a>
            </div>
          </address>
        </motion.div>
      </div>
    </div>;
}